import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import { academyCustomCSS } from '~/constants/academyCustomCSS';

export default class EndUserCardContainer extends Component {
  constructor(props) {
    super(props);

    this.state = { sortInitialized: false };
  }

  componentDidMount() {
    this.mounted = true;
    if (this.props.onSortStop && this.props.sortEnabled) this.initSort();
  }

  componentDidUpdate(prevProps) {
    const $cards = $(this.cards);

    if (this.mounted && this.props.sortEnabled && !prevProps.sortEnabled) {
      this.initSort();
      $cards.sortable('enable');
    } else if (this.mounted && !this.props.sortEnabled && prevProps.sortEnabled) {
      $cards.sortable('disable');
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    return (
      <div className="container-fluid container-fluid--edgeless">
        <div
          ref={(cards) => (this.cards = cards)}
          className={`${academyCustomCSS.cardList.cardsContainer} end-user-card-container--cards row`}
        >
          {this.getEmptyMessage()}
          {this.getChildrenWithLayout()}
        </div>
      </div>
    );
  }

  getEmptyMessage = () => {
    const { emptyMessage } = this.props;
    if (!(emptyMessage && this.isEmpty())) return;

    return (
      <EmptyMessageWrapper>
        <NilStateGraphic src="/images/learner_nil_state.svg" />
        <div className="end-user-card-container--empty-message text-center">
          {emptyMessage.message}
          <div className="end-user-card-container--empty-message-subtitle">{emptyMessage.subtitle}</div>
        </div>
      </EmptyMessageWrapper>
    );
  };

  isEmpty = () => {
    const { children } = this.props;
    return !children || children.length === 0;
  };

  getChildrenWithLayout = () => {
    const { children } = this.props;

    return _.map(children, (child, index) => (
      <div key={`card-container--card-${index}`} className={this.getLayoutClass()}>
        {child}
      </div>
    ));
  };

  getLayoutClass = () => this.props.layoutClass || EndUserCardContainer.defaultCardLayout;

  initSort = () => {
    if (this.state.sortInitialized) return;
    const me = this;
    let firstSort = true;
    const $cards = $(this.cards);

    $cards.sortable({
      items: '> *:not(.end-user-card-container--empty-message)',
      helper: 'clone',
      scrollSensitivity: 10,
      containment: this.props.container,
      placeholder: `${this.getLayoutClass()} end-user-card--placeholder`,
      distance: '5',
      start(e, ui) {
        // Handles weird scroll-related flicker
        if (firstSort) {
          $cards.sortable('refreshPositions');
          firstSort = false;
        }

        // Size placeholder to card, not container
        const $item = $(ui.item);
        const $placeholder = $(ui.placeholder);

        const $card = $item.find('.end-user-card');
        $placeholder.height($card.height());

        const marginBottom = $item.find('.card-wrapper').css('margin-bottom');
        $placeholder.css({ 'margin-bottom': marginBottom });
      },
      tolerance: 'pointer',
      stop(event, ui) {
        me.props.onSortStop($cards, event, ui);
      },
    });

    this.setState({ sortInitialized: true });
  };
}

const EmptyMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const NilStateGraphic = styled.img`
  max-width: 80%;
`;

EndUserCardContainer.defaultCardLayout = 'col-lg-3 col-md-4 col-sm-6 col-xs-12';
